<template>
  <div class="device-type-detail">
    <div class="banner" v-if="isMobile" :style="{ backgroundImage: `url(${detail_data.mbanner || detail_data.banner})` }">
      <h1>Hardware</h1>
      <div class="inner_btn">
        <button @click="goToContact(2)" class="inner-le">Eco-cooperation</button>
        <button @click="goToContact(3)" class="inner-ri">Contact us</button>
      </div>
    </div>
    <div class="banner" v-else :style="{ backgroundImage: `url(${detail_data.banner})` }">
      <h1>Hardware</h1>
      <div class="inner_btn">
        <button @click="goToContact(2)" class="inner-le">Eco-cooperation</button>
        <button @click="goToContact(3)" class="inner-ri">Contact us</button>
      </div>
    </div>
    <div class="detail_main">
      <div class="detail_title">
        <h1>{{ detail_data.name }}</h1>
      </div>
      <div class="content" v-html="detail_data.context"></div>
    </div>

    <div v-if="deviceList.length" class="success_outer">
      <div class="success">
        <h1>Related Products</h1>
        <div class="succ-box" v-if="isMobile">
          <el-row :gutter="20">
            <el-col :span="24" v-for="item in deviceList" :key="item.id" style="height: 18em;">
              <div class="grid-content">
                <div class="grid-top">
                  <img :src="item.thumbnail" alt="">
                </div>
                <div class="grid-bottom" @click="gotoDevice(item.id)">
                  <h3>{{ item.name }}</h3>
                  <el-button>View More</el-button>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="succ-box" v-else>
          <el-row :gutter="20">
            <el-col :span="8" v-for="item in deviceList" :key="item.id" style="height: 25em;">
              <div class="grid-content">
                <div class="grid-top">
                  <img :src="item.thumbnail" alt="">
                </div>
                <div class="grid-bottom">
                  <h3>{{ item.name }}</h3>
                  <el-button @click="gotoDevice(item.id)">View More</el-button>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup name="DeviceTypeDetailEN">
import { ref, onMounted, onUnmounted, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { getDeviceTypeDetail } from '@/api/deviceType'
import { getDevicePage } from '@/api/device'

const route = useRoute()
const router = useRouter()
const id = ref(route.query.id)
const detail_data = ref({})
const deviceList = ref([])

onMounted(() => {
  window.scrollTo(0, 0)
  checkMobile()
  window.addEventListener('resize', checkMobile)
  renderDetail()
})
onUnmounted(() => {
  window.removeEventListener('resize', checkMobile)
})

watch(() => route.query.id, (newId) => {
  if (newId) {
    id.value = newId
    window.scrollTo(0, 0)
    renderDetail()
  }
})

const isMobile = ref(false)
const checkMobile = () => {
  isMobile.value = window.innerWidth <= 1024
}

const emit = defineEmits(['scroll-to-contact'])
function goToContact(type) {
  emit('scroll-to-contact', type)
}

function gotoDevice(id) {
  router.push(`/en/productharddetail?id=${id}`)
}

async function renderDetail() {
  const res = await getDeviceTypeDetail(id.value)
  detail_data.value = res.data
  const deviceRes = await getDevicePage({ appId: 2, deviceTypeId: id.value, current: 1, size: 100 })
  deviceList.value = deviceRes.data?.records || []
}
</script>

<style scoped>
.device-type-detail {
  width: 100%;
}

.banner {
  overflow: hidden;
  width: 100%;
  height: 12em;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  color: white;
  background-color: #ddd;
  margin-bottom: 8em;
  background-size: 100% 100%;
  background-position: center;
  text-align: left;
  background-repeat: no-repeat;
}

.inner_btn {
  margin-left: 18%;
  font-size: 0.8em;
}

.inner-le, .inner-ri {
  width: 10em;
  height: 3em;
  border-radius: 1.5em;
  font-size: 1em;
  border: transparent;
  cursor: pointer;
  margin: 1.5em auto;
}

.inner-le {
  background-color: orange;
  color: white;
  margin-right: 1em;
}

.inner-ri {
  background-color: skyblue;
  color: white;
}

.banner h1 {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  width: 65%;
  margin: 0 auto;
  margin-top: 1em;
  margin-left: 18%;
}

.detail_main {
  width: 60%;
  margin: 2em auto;
}

.detail_main .detail_title {
  width: 100%;
  text-align: center;
  margin-bottom: 2em;
}

.detail_main .detail_title h1 {
  margin-bottom: 0.5em;
}

:deep(.content) {
  line-height: 1.8em;
  font-size: 15px;
}

:deep(.content img) {
  max-width: 100%;
  height: auto;
}

:deep(.content p) {
  margin: 0.5em 0;
}

:deep(.content h1),
:deep(.content h2),
:deep(.content h3),
:deep(.content h4) {
  margin: 1em 0 0.5em;
}

.success_outer {
  width: 100%;
  overflow: hidden;
  background-color: #F9FAFC;
}

.success {
  width: 60%;
  margin: 4em auto;
}

.success > h1 {
  margin-bottom: 1em;
}

.success .succ-box {
  margin-top: 4em;
}

.success .succ-box .el-row {
  display: flex;
  flex-wrap: wrap;
}

.success .succ-box .el-col {
  display: flex;
  flex-direction: column;
}

.success .succ-box .grid-content {
  width: 100%;
  height: 100%;
  background-color: #fff;
  display: flex;
  flex-direction: column;
}

.success .succ-box .grid-content .grid-top {
  width: 100%;
  height: 55%;
}

.success .succ-box .grid-content .grid-top img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.success .succ-box .grid-content .grid-bottom {
  width: 90%;
  height: 45%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.success .succ-box .grid-content .grid-bottom h3 {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  margin: 0.5em 0;
}

.success .succ-box .grid-content .grid-bottom .el-button {
  width: 50%;
  margin: 0.5em 0;
  border: 1px solid #000;
  border-radius: 0;
  color: #000;
}

@media (max-width: 1024px) {
  .banner {
    height: 12em;
    margin-bottom: 1em;
    text-align: center;
  }

  .banner h1 {
    font-size: 1.2em;
    margin-top: 4em;
  }

  .inner_btn {
    margin-left: 0;
  }

  .inner-le, .inner-ri {
    font-size: 0.8em;
    height: 2.5em;
  }

  .detail_main {
    width: 90%;
  }

  .success_outer {
    background-color: #005BAC;
  }

  .success {
    text-align: center;
    width: 90%;
    margin: 1em auto;
  }

  .success > h1 {
    font-size: 1.2em;
  }

  .success .succ-box {
    margin-top: 1em;
  }

  .success .succ-box .grid-bottom h3 {
    font-size: 1em;
  }

  .success .succ-box .grid-bottom .el-button {
    width: 20%;
    font-size: 0.8em !important;
  }
}
</style>
